<div class="map-geo-fence-container">
  <div class="row-1">
    <button mat-button mat-raised-button class="clear-button"
            (click)="clearGeoFence()" color="accent">
      Clear Geo Fence
    </button>
  </div>
  <hmt-map class="map" #mapComponent (geoFence)="saveDrawnGeoFence($event)"></hmt-map>
</div>
